<template>
  <manage-suites :suites="suites" :typeString="'Service Provider'" :meeting-id="this.$route.params.id"></manage-suites>
</template>

<script>
import ManageSuites from '../shared/ManageSuites';
import { db } from '@/services/firebase';

export default {
  data() {
    return {
      meeting: {},
      suites: []
    };
  },

  firestore() {
    const meeting = db.collection('meetings').doc(this.$route.params.id);
    const suites = meeting.collection('suites').where('type', '==', 'Service Provider');

    return {
      meeting,
      suites
    };
  },

  components: {
    ManageSuites
  }
};
</script>



// WEBPACK FOOTER //
// src/components/meeting/ManageServiceProviders.vue